import { Reveal, SectionTag } from "./Reveal";
import { Check, Wrench } from "lucide-react";

const CURRENT = "Nissan 350Z (Z33)";
const COMING = [
  "370Z (Z34)",
  "Silvia S13 / S14 / S15",
  "Skyline R33 / R34",
  "Supra A80",
  "RX-7 FD",
];

export const Fitment = () => (
  <section
    id="fitment"
    className="relative py-24 md:py-36 px-5 md:px-10 overflow-hidden"
    data-testid="fitment-section"
  >
    <div className="absolute -right-20 top-10 w-[38vw] h-[38vw] text-white/[0.025] rp-checker pointer-events-none" />
    <div className="mx-auto max-w-[1400px] grid md:grid-cols-2 gap-14 items-center">
      <div>
        <SectionTag index="03" label="Fitment" />
        <h2 className="font-display text-[clamp(2.4rem,6.5vw,5.5rem)] text-white mb-6">
          Right car.
          <br />
          <span className="text-[#e31e24]">Right fit.</span>
        </h2>
        <p className="text-white/60 text-base md:text-lg leading-relaxed max-w-lg">
          Rayce Parts is built around dedicated fitment. No stretching a
          universal shape across ten platforms — every part is modelled for a
          specific chassis so it drops in like factory.
        </p>
      </div>

      <Reveal delay={0.1}>
        <div className="bg-[#141414] border border-white/10 p-8 md:p-10">
          <div className="flex items-center gap-3 mb-8">
            <Wrench size={18} className="text-[#e31e24]" />
            <span className="font-mono-rp text-xs tracking-[0.25em] uppercase text-white/60">
              Platform Support
            </span>
          </div>

          <div className="mb-8 pb-8 border-b border-white/10">
            <span className="font-mono-rp text-[11px] tracking-[0.2em] uppercase text-white/40">
              Currently building
            </span>
            <div
              className="mt-3 flex items-center gap-3"
              data-testid="fitment-current"
            >
              <span className="grid place-items-center h-7 w-7 bg-[#e31e24]">
                <Check size={16} className="text-white" />
              </span>
              <span className="font-display text-3xl md:text-4xl text-white">
                {CURRENT}
              </span>
            </div>
          </div>

          <span className="font-mono-rp text-[11px] tracking-[0.2em] uppercase text-white/40">
            Expanding to more platforms
          </span>
          <div className="mt-4 flex flex-wrap gap-2.5">
            {COMING.map((p) => (
              <span
                key={p}
                className="border border-white/15 text-white/60 px-3 py-1.5 text-sm hover:border-[#e31e24] hover:text-white transition-colors"
                data-testid={`fitment-coming-${p}`}
              >
                {p}
              </span>
            ))}
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
